<template lang="pug">
.caseSingleText
  .single-box
    Form(:model="question")
      .single-stem
        Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
          @click='showAIDialog()',v-if='enableAI') AI生成
        Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
          Form(:model="aiForm" :label-width="80")
            FormItem(label="生成数量")
              InputNumber(v-model="aiForm.count" :min="1" :max="10" placeholder="请输入生成数量")
            FormItem(label='提示词',prop="stem")
              Input(v-model='aiForm.system' placeholder='请填写提示词'
                type="textarea" :rows="3")
        FormItem
          Input.input1(type='text',placeholder='案例背景',v-model='question.title' :maxlength="30",:disabled="seeState")
        iDelModel.ide(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
        FormItem
          Input.input2(type='textarea',placeholder='正文内容',v-model='question.stem',:rows="4",:disabled="seeState").zindex6
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
import Bus from "../../utils/bus";
export default {
  components: {
    iDelModel
  },
  inject: ["seeState"],

  props: ["data", "haId", "taskId", "enableAI"],
  data() {
    return {
      question: {
        title: "",
        stem: ""
      },
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, system: "" };
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "SINGLETEXT",
          count: this.aiForm.count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          score: 2,
          system: this.aiForm.system
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
              Bus.$emit("refresh-task", this.taskId);
          } else {
              this.$emit("refresh-query");
          }
        }
      });
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="stylus">
.caseSingleText
  .single-box
    padding 24px
    width 100%
    margin 0 auto
    .single-stem
      position relative
      .ide
        margin-top -10px
      .input1
        width 80%
        float left
      .ivu-form-item-content
        // margin-right 300px
      .btns
        position absolute
        top -5px
        right 0px
        .ivu-icon
          color #3A76D2FF
          font-size 22px
          top 0
          margin-right 12px
          background #F2F5FAFF
          width 24px
          height 24px
          border-radius 4px
          text-align center
          line-height @height
          &:hover
            cursor pointer
</style>
